import { useState, useEffect } from 'react';
import ProductCard from './ProductCard';
import Cookies from 'js-cookie';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function HomeProduct(props) {
  const history = useHistory();
  const { t } = useTranslation();
  const { title, langs, remove, isLocal } = props;
  const [mainL, setMainL] = useState('en-US');
  const [showp, setShowp] = useState(false);

  useEffect(() => {
    const mycoockie = Cookies.get('i18next');
    if (mycoockie === 'fr') {
      setMainL('fr-CA');
    } else if (mycoockie === 'es') {
      setMainL('es-US');
    }
  }, []);

  let result = JSON.parse(localStorage.getItem('bestSeller'));
  let symbol = JSON.parse(localStorage.getItem('machine'))?.currency?.symbol;
  let machineID = JSON.parse(localStorage.getItem('machine'))?._id;
  symbol = symbol ? symbol : '$';

  const products = result.map((prod, i) => {
    // const url = `${process.env.REACT_APP_SERVER_API}/pictures/${prod.productPictures[0]}/${prod.referTo}`;
    const url = isLocal
      ? `${process.env.REACT_APP_LOCAL_API}/pictures/products/${prod.productPictures[0]}`
      : `${process.env.REACT_APP_SERVER_API}/pictures/${prod.productPictures[0]}/${prod.referTo}`;
    return (
      <ProductCard
        remove={remove}
        langs={langs}
        mainL={mainL}
        symbol={symbol}
        setShowp={setShowp}
        cart={props.cart}
        alterquantity={props.alterquantity}
        add={props.add}
        decreStock={props.decreStock}
        prod={prod}
        image={url}
        key={i}
        twoLine={true}
        machineID={machineID}
      />
    );
  });

  const goToALLProducts = () => {
    history.push(`/machineUI/category/cate/all/all`);
  };

  return (
    <div className="homeProduct" style={{ marginBottom: '30px' }}>
      <h1 className="homeProductText"> {t(`TravelWifi Products`)}</h1>
      {/* <div className="home-product-container d-flex">{products}</div> */}
      <div className="home-product-container">
        <div className="home-products">{products}</div>
        <div>
          <div className="view-more-button" onClick={goToALLProducts}>
            {t('VIEW MORE')}
          </div>
        </div>
      </div>
    </div>
  );
}
export default HomeProduct;
